import { render } from "./CardTwentyOne.vue?vue&type=template&id=239d2bf6"
import script from "./CardTwentyOne.vue?vue&type=script&lang=js"
export * from "./CardTwentyOne.vue?vue&type=script&lang=js"

import "./CardTwentyOne.vue?vue&type=style&index=0&id=239d2bf6&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__